module.exports = __webpack_public_path__ + "img/slider_5.8d6f8b30.jpg";